import { render } from "./CoffeeToTo.vue?vue&type=template&id=666451b9"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/CoffeeToTo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "666451b9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('666451b9', __exports__)) {
    api.reload('666451b9', __exports__)
  }
  
  module.hot.accept("./CoffeeToTo.vue?vue&type=template&id=666451b9", () => {
    api.rerender('666451b9', render)
  })

}


export default __exports__